<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CN" id="_idParaDest-3"><span class="CharOverride-3">House Rivals</span></p>
<p class="ParaOverride-1"><span class="CharOverride-4">Mike Lawson</span></p>
<p class="BT1stPara ParaOverride-2"><span class="CharOverride-5"><img alt="" class="_idGenObjectAttribute-1" src="image/L-1.png"/></span></p>
<p class="BT1stPara ParaOverride-3"><span class="CharOverride-5">Atlantic Monthly Press</span></p>
<p class="BT1stPara ParaOverride-3"><span class="CharOverride-6">New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook_4345-2.vue?79a992de